import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Globalize from 'globalize';
import app from '../../app';
import { get as loadView } from '../Views';
import 'jquery-slimscroll';
import 'jquery-hoverintent';

export default Backbone.View.extend({

    events: {
        'click > a': 'onClickCompareProducts',
        'click a.btn.btn-primary': 'onClickCompareProducts',
        'focus #header-productComparisonLink': 'tabFocusComparison',
        'blur .product-comparison-list.header-status-list .footer a': 'tabBlurComparison'
    },

    initialize: function () {
        this.comparisonList = app.getProductComparisonList();
        this.comparisonList.on('all', this.refresh, this);

        this.refresh();

        this.initHover();
        this.initScrolling();
    },

    refresh: function () {
        if (_.isUndefined(this.details)) {
            this.details = $.Mustache.jQ('header-product-comparison-list');
        }

        const list = this.details.find('ul');

        list.children('li').remove();

        this.comparisonList
            .each((catalogItem) => {
                const description = (catalogItem.get('descriptionShort') === null) ?
                '' :
                catalogItem.get('descriptionShort');
                const shortenedDescription = description.substr(0, 28) + (description.length > 28 ? '...' : '');

                const decodedDescription = $('<div/>').html(description);
                const decodedShortDescription = $('<div/>').html(shortenedDescription);

                const supplierCatalog = catalogItem.get('supplierCatalog');
                const extSupplierId = (supplierCatalog.supplier.externalSupplierId === null) ? '' : supplierCatalog.supplier.externalSupplierId;
                const supplierCatalogId = (supplierCatalog.catalogId === null) ? '' : supplierCatalog.catalogId;
                let imageSource = null;
                let imageUrl = null;

                const index = this.getMainImageIndex(catalogItem);
                if (catalogItem.get('images')[index] !== undefined) {
                    imageSource = catalogItem.get('images')[index].source;

                    if (imageSource.match(/^http/)) {
                        imageUrl = imageSource;
                    } else {
                        imageUrl = `${window.POne.config.mediaServerUrl}/product-images/${extSupplierId}/${supplierCatalogId}/${imageSource}`;
                    }
                }

                if (_.isNull(imageUrl)) {
                    const size = 70;
                    imageUrl = `${app.config.contextPath}/resources/images/no-image-${size}.png`;
                }

                // Check if the Shopping-cart item is part of core assortment
                let coreAssortment = false;
                $(catalogItem.get('customFields')).each((field, elem) => {
                    if (elem.name === 'Kernsortiment') {
                        coreAssortment = true;
                    }
                });

                const data = { dataSourceId: catalogItem.get('dataSourceId'),
                    id: catalogItem.id,
                    description: decodedDescription.text(),
                    imageUrl: imageUrl,
                    shortenedDescription: decodedShortDescription.text(),
                    price: Globalize.format(catalogItem.get('defaultPrice'), 'c'),
                    quantity: Globalize.format(catalogItem.get('quantity'), 'n')
                };
                // Based on the boolean decide to add a core assortment item or normal
                if (coreAssortment) {
                    list.append($.Mustache.jQ('header-product-comparison-list-item-coreAssortment', data));
                } else {
                    list.append($.Mustache.jQ('header-product-comparison-list-item', data));
                }
            });

        const comparisonListSize = this.comparisonList.size();
        this.$el.find('.size').text(`${comparisonListSize} ${Globalize.localize('products')}`);
        if (this.$el.find('.product-comparison-list').length === 0) {
            this.$el.append(this.details);
        }

        this.updateScrolling();

        this.updateLinks();

        this.trigger('refresh');
    },

    initHover: function () {
        if (this.comparisonList.length > 0) {
            this.$el.hoverIntent({
                over: () => this.showDetails(),
                out: () => this.hideDetails(),
                timeout: 500
            });
        } else {
            this.$el.hover(
                () => this.showDetails(),
                () => this.hideDetails()
            );
        }
    },

    onClickCompareProducts: function (event) {
        event.preventDefault();

        if (this.comparisonList.length === 0) {
            window.location.href = $(event.currentTarget).attr('href');
            return;
        }

        this.showProductComparison();
    },

    updateLinks: function () {
        const links = this.$('> a, a.btn.btn-primary');

        let baseUrl = this.$('> a').attr('href');
        if (baseUrl.indexOf('?') > -1) {
            baseUrl = baseUrl.substr(0, baseUrl.indexOf('?'));
        }

        const urlParams = this.comparisonList.map(catalogItem => {
            const dataSource = catalogItem.get('dataSourceId');
            return `catalogItemId=${dataSource}-${catalogItem.id}`;
        });

        links.attr('href', `${baseUrl}?${urlParams.join('&')}`);
    },

    getModal: function () {
        const url = `${this.$('> a').attr('href')}&modal=true`;

        // create new modal source from template
        const modal = $.Mustache.jQ('modal', {
            id: 'product-comparison-modal',
            title: this.$('> a > h1').text()
        }).addClass('product-comparison-modal loading');
        modal.attr('tabindex', -1);
        // load details
        $.get(url, (data) => {
            // extract page content and remove title
            const modalContent = $(data);
            modalContent.children('header').remove();

            // run image fallback plugin on new content
            modalContent.find('img[data-fallback-src]').imageFallback();

            // append content and create modal, but hide for now
            modal.removeClass('loading');
            modal.find('.modal-body').append(modalContent);

            const footer = modal.find('.modal-footer');
            const closeButton = footer.children('a[data-dismiss]');

            // make sure that the "close" button works
            closeButton.click((event) => {
                event.preventDefault();
                modal.modal('hide');
            });

            // get content view name from article element
            const contentViewClass = modalContent.attr('class').split(' ')[0];

            // initialize view
            return loadView(contentViewClass)
                .then(({ Controller }) => new Controller({
                    el: modalContent
                }));
        }, 'html');

        return modal;
    },

    initScrolling: function () {
        this.details.find('ul').slimScroll({
            height: `${this.getScrollingHeight()}px`
        });

        $(window).scroll(_.bind(this.updateScrolling, this));
        $(window).resize(_.bind(this.updateScrolling, this));
    },

    updateScrolling: function () {
        const height = `${this.getScrollingHeight()}px`;
        this.details.find('ul').css('height', height);
        this.details.children('.slimScrollDiv').css('height', height);
        this.details.children('.slimScrollDiv').attr('role', 'scrollbar');
    },

    getScrollingHeight: function () {
        const listSize = this.details.find('ul > li').length;
        const maxVisibleListSize = (listSize > 6) ? 6.5 : listSize;

        const listItemHeight = 70;
        let height = (listItemHeight * maxVisibleListSize); // 6 1/2 list items at max visible
        const availableHeight = $(window).height() - (this.details.offset().top - $(window).scrollTop()) - 200; // 200px to be on the save side

        while (height > availableHeight) {
            height = height - listItemHeight;
        }

        return height;
    },

    showProductComparison: function () {
        const modal = this.getModal();

        // remove existing modals from DOM and add new one
        $('body')
            .find(`#product-comparison-modal`)
            .remove();

        $('body')
            .append(modal);

        // show
        modal.modal('show');
    },

    showDetails: function () {
        const container = this.$el;
        const details = container.children('.product-comparison-list');

        container.addClass('open');
        details.hide();

        if (this.comparisonList.length > 0) {
            details.show();
        } else {
            container.addClass('empty');
        }
    },

    hideDetails: function () {
        const container = this.$el;
        const details = container.children('.product-comparison-list');

        container.removeClass('empty');

        details.hide();
        container.removeClass('open');
    },

    getMainImageIndex: function (catalogItem) {
        let index = 0;
        const images = catalogItem.get('images');
        if (!_.isUndefined(images)) {
            for (let idx = 0; idx < images.length; idx += 1) {
                if (images[idx].purpose === 'main_thumbnail') {
                    index = idx;
                    break;
                }
            }
        }

        return index;
    },

    tabFocusComparison: function (event) {
        if (this.comparisonList.length > 0) {
            this.showDetails();
        }
    },

    tabBlurComparison: function (event) {
        if (this.comparisonList.length > 0) {
            this.hideDetails();
        }
    }
});


// WEBPACK FOOTER //
// ./views/catalog/ProductComparisonElementController.js